import { storeToRefs } from 'pinia'
import { useEcoStore } from '../store'
import { useAxios } from '@/hooks/web/useAxios'
import { ecoCommonInfo } from '../hooks/UserBasicInfo'

const { ecoLang, ecoOrgId } = ecoCommonInfo()
const request = useAxios()

const ecoStore = useEcoStore()
const { dayOfStart, timezone } = storeToRefs(ecoStore)

const getOrgId = () => {
  const origin = window.location.origin
  let orgId = ecoOrgId.value

  if (origin?.includes('desk-')) {
    orgId = ecoOrgId.value
  } else {
    orgId = ecoStore.ecoOrgId
  }

  return orgId
}

const getFn = (option: any) => {
  const header = option.headers || {}
  if (header.timezone === undefined) {
    header.timezone = timezone.value
  }
  if (header.timeoffset === undefined) {
    header.timeoffset = dayOfStart.value
  }
  if (header.language === undefined) {
    header.language = ecoLang.value
  }
  if (header['org-id'] === undefined) {
    header['org-id'] = getOrgId()
  }
  option.headers = header
  return request.get(option)
}

const postFn = (option: any) => {
  const header = option.headers || {}
  if (header.timezone === undefined) {
    header.timezone = timezone.value
  }
  if (header.timeoffset === undefined) {
    header.timeoffset = dayOfStart.value
  }
  if (header.language === undefined) {
    header.language = ecoLang.value
  }
  if (header['org-id'] === undefined) {
    header['org-id'] = getOrgId()
  }
  option.headers = header
  return request.post(option)
}

const deleteFn = (option: any) => {
  const header = option.headers || {}
  if (header.timezone === undefined) {
    header.timezone = timezone.value
  }
  if (header.timeoffset === undefined) {
    header.timeoffset = dayOfStart.value
  }
  if (header.language === undefined) {
    header.language = ecoLang.value
  }
  if (header['org-id'] === undefined) {
    header['org-id'] = getOrgId()
  }
  option.headers = header
  return request.delete(option)
}

const putFn = (option: any) => {
  const header = option.headers || {}
  if (header.timezone === undefined) {
    header.timezone = timezone.value
  }
  if (header.timeoffset === undefined) {
    header.timeoffset = dayOfStart.value
  }
  if (header.language === undefined) {
    header.language = ecoLang.value
  }
  if (header['org-id'] === undefined) {
    header['org-id'] = getOrgId()
  }
  option.headers = header
  return request.put(option)
}

export const useEcoAxios = () => {
  return {
    get: getFn,
    post: postFn,
    delete: deleteFn,
    put: putFn
  }
}
